var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"alert alert-warning"},[_vm._v("You are not authorized to view this page.")])])
}]

export { render, staticRenderFns }